export default "__VITE_ASSET__ef40c3db__"